import React from 'react';
import Header from '../header/header.js';
import Company from '../company/company.js';
import ProjectItem from '../project-item/project-item.js';
import OtherStuff from '../other-stuff/other-stuff.js';
import { companies, getProjectSummariesByCompany } from '../../data/projects.js';

export default function HomePage() {
    return (
        <>
            <Header />
            
            <Company 
                logo={companies.remote.logo}
                name={companies.remote.name}
                period={companies.remote.period}
            >
                {getProjectSummariesByCompany('remote').map((project, index) => (
                    <ProjectItem
                        key={project.slug || project.externalLink}
                        title={project.title}
                        description={project.description}
                        slug={project.slug}
                        externalLink={project.externalLink}
                        projectData={project}
                        media={project.media}
                        priority={index === 0}
                    />
                ))}
                <OtherStuff items={companies.remote.otherStuff} companyName={companies.remote.name} />
            </Company>

            <Company 
                logo={companies.secondNature.logo}
                name={companies.secondNature.name}
                period={companies.secondNature.period}
            >
                {getProjectSummariesByCompany('secondNature').map(project => (
                    <ProjectItem
                        key={project.slug || project.externalLink}
                        title={project.title}
                        description={project.description}
                        slug={project.slug}
                        externalLink={project.externalLink}
                        projectData={project}
                        media={project.media}
                    />
                ))}
                <OtherStuff items={companies.secondNature.otherStuff} companyName={companies.secondNature.name} />
            </Company>

            <Company 
                name={companies.other.name}
                period={companies.other.period}
            >
                {getProjectSummariesByCompany('other').map(project => (
                    <ProjectItem
                        key={project.slug || project.externalLink}
                        title={project.title}
                        description={project.description}
                        slug={project.slug}
                        externalLink={project.externalLink}
                        projectData={project}
                        media={project.media}
                    />
                ))}
                <OtherStuff items={companies.other.otherStuff} companyName={companies.other.name} />
            </Company>
        </>
    );
}
